var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryOnProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.00006,
    width: 34,
    height: 34,
    rx: 17,
    fill: "white",
    stroke: "#94ABBF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1982 24.0001H18.6664M18.6664 24.0001V11.6251C18.6664 11.3267 18.5435 11.0405 18.3247 10.8296C18.1059 10.6186 17.8092 10.5001 17.4998 10.5001H9.33328M18.6664 24.0001L20.848 24.0001M18.6664 24.0001L18.6664 12.7501H23.6246C23.8865 12.7407 24.1439 12.8167 24.3556 12.9656C24.5672 13.1146 24.7207 13.328 24.7912 13.5713L25.6662 16.6876L27.1129 17.0363C27.3717 17.0979 27.6009 17.2431 27.7622 17.4478C27.9235 17.6525 28.0073 17.9043 27.9995 18.1613V22.8751C27.9995 23.1734 27.8766 23.4596 27.6578 23.6706C27.439 23.8815 27.1423 24.0001 26.8329 24.0001H25.7946M7 19.5001V22.8751C7 23.1734 7.12291 23.4596 7.3417 23.6706C7.56049 23.8815 7.85723 24.0001 8.16664 24.0001H9.18161M7 15.0001H13.9998M11.6666 21.7501C11.2051 21.7501 10.754 21.882 10.3703 22.1293C9.98655 22.3765 9.68749 22.7279 9.51089 23.139C9.33429 23.5502 9.28808 24.0026 9.37811 24.439C9.46814 24.8755 9.69036 25.2764 10.0167 25.591C10.343 25.9057 10.7587 26.12 11.2114 26.2068C11.664 26.2936 12.1331 26.2491 12.5595 26.0788C12.9858 25.9085 13.3502 25.6201 13.6066 25.2501C13.863 24.8801 13.9998 24.4451 13.9998 24.0001C13.9998 23.4033 13.754 22.831 13.3164 22.4091C12.8789 21.9871 12.2854 21.7501 11.6666 21.7501ZM23.3329 21.7501C22.8715 21.7501 22.4204 21.882 22.0366 22.1293C21.6529 22.3765 21.3539 22.7279 21.1773 23.139C21.0007 23.5502 20.9545 24.0026 21.0445 24.439C21.1345 24.8755 21.3568 25.2764 21.6831 25.591C22.0094 25.9057 22.4251 26.12 22.8777 26.2068C23.3304 26.2936 23.7995 26.2491 24.2259 26.0788C24.6522 25.9085 25.0166 25.6201 25.273 25.2501C25.5294 24.8801 25.6662 24.4451 25.6662 24.0001C25.6662 23.4033 25.4204 22.831 24.9828 22.4091C24.5452 21.9871 23.9518 21.7501 23.3329 21.7501Z",
    stroke: "#94ABBF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryOnProcess);
export default __webpack_public_path__ + "static/media/DeliveryOnProcess.9a3fb1ae2b1684abff9d599083c3668a.svg";
export { ForwardRef as ReactComponent };